import React, { HTMLAttributes, ReactNode } from 'react';
import { getColumnClassNames } from './utils';
import { getClassNames } from '../../utils';
import withTheme from '../../hocs/withTheme';
import './Grid.css';

// 1. Define the possible types for Column size
// It can be a string ("md-6"), a number (12), or an array of both (["sm-12", "md-6"])
type ColumnSize = string | number;

interface ColumnProps extends HTMLAttributes<HTMLDivElement> {
    /** Container size or list of sizes for different screen width. */
    /** Names like 'lg-1','md-2, 'sm-3' etc. or numbers 1-12 are allowed */
    size?: ColumnSize | ColumnSize[];
    /** @ignore */
    children?: ReactNode;
    /** @ignore */
    className?: string;
}

const Column: React.FC<ColumnProps> = ({ 
    size = 1, 
    children = null, 
    className = '', 
    ...props 
}) => {
    return (
        <div
            {...props}
            className={getClassNames(className, getColumnClassNames(size))}
        >
            {children}
        </div>
    );
};

export default withTheme(Column);